/**
 * 05 快速建立：x 台 INV、每台 y 個 MPPT、每個 MPPT z 格 → mppt_string_map 的列。
 *
 * 串列索引照 MPPT 順序排下去（MPPT1 佔 0..z-1、MPPT2 接著排…），
 * 編號跟後端 `stringIdsFromMap` 同一套：第三段是這個 MPPT 裡的第幾格，空接也佔一格（ADR-0013）。
 *
 * @param {string} siteCode
 * @param {number} invCount
 * @param {number} mpptCount 每台幾個 MPPT
 * @param {number} perMppt 每個 MPPT 幾格
 * @param {Object<string, boolean>} dead 鍵是 `INV索引/串列索引`，true = 空接
 */
const buildMpptRows = (siteCode, invCount, mpptCount, perMppt, dead = {}) => {
  const rows = []
  for (let inv = 0; inv < invCount; inv++) {
    for (let m = 1; m <= mpptCount; m++) {
      for (let k = 1; k <= perMppt; k++) {
        const idx = (m - 1) * perMppt + k - 1
        rows.push({
          site_code: siteCode,
          inv_index: inv,
          string_index: idx,
          mppt_no: m,
          // 空接留空 —— 留空就是「這個位置沒接東西」（ADR-0012）
          string_id: dead[`${inv}/${idx}`] ? null : `INV${inv + 1}-${m}-${k}`
        })
      }
    }
  }
  return rows
}

export { buildMpptRows }
